/**
 * Ocena hasła przy zakładaniu konta, przed wysłaniem (strona `/rejestracja` i okno konta w Projekcie 3D dla gościa).
 * Te same proste reguły co walidatory hasła w Django (długość, same cyfry, popularne, podobne do e-maila).
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

const POPULARNE = ['12345678', '123456789', '1234567890', 'password', 'password1', 'qwerty123', 'qwertyuiop',
  'haslo123', 'zaq12wsx', '11111111', 'fotowoltaika', 'iloveyou']
export const ocenHaslo = (haslo, email) => {
  const dl = haslo.length
  const male = haslo.toLowerCase()
  const popularne = POPULARNE.includes(male)
  const cyfry = dl > 0 && /^\d+$/.test(haslo)
  const login = email.split('@')[0].toLowerCase()
  const podobne = login.length >= 4 && male.includes(login)
  const roznorodnosc = [/[a-ząćęłńóśźż]/, /[A-ZĄĆĘŁŃÓŚŹŻ]/, /\d/, /[^A-Za-z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/]
    .filter((r) => r.test(haslo)).length
  let wynik = dl > 0 ? 1 : 0
  if (dl >= 8 && roznorodnosc >= 2) wynik = 2
  if (dl >= 10 && roznorodnosc >= 3) wynik = 3
  if ((dl >= 12 && roznorodnosc >= 3) || dl >= 16) wynik = 4
  if (popularne || cyfry || podobne) wynik = dl > 0 ? 1 : 0
  const blad = dl === 0 ? 'Wpisz hasło.'
    : dl < 8 ? 'Hasło musi mieć co najmniej 8 znaków.'
      : popularne ? 'To hasło jest zbyt popularne, wybierz inne.'
        : cyfry ? 'Hasło nie może składać się z samych cyfr.'
          : podobne ? 'Hasło jest zbyt podobne do adresu e-mail.' : ''
  return {
    wynik, ok: !blad, blad, popularne,
    reguly: [
      ['Co najmniej 8 znaków', dl >= 8],
      ['Nie same cyfry', dl > 0 && !cyfry],
      ['Nie popularne i nie jak e-mail', dl > 0 && !popularne && !podobne],
    ],
  }
}
